import { lazy } from 'react';

import type { TApplicationRoute } from '@modules/core/types';

import { PRODUCT_PACK_ROUTE_PATHS } from './config';

export const PRODUCT_PACK_ROUTES: TApplicationRoute[] = [
  {
    id: 'cards-debit-card-product-pack',
    path: PRODUCT_PACK_ROUTE_PATHS.productPack,
    component: lazy(() => import('./pages/product-pack-page')),
    layout: 'default',
    permissions: { roles: [], scopes: ['debit-card-product-pack'] },
    menu: {
      title: 'Product Pack',
    },
  },
];
